let currentProduct;

const waitForMazingFunction = new Promise((resolve) => {
  const interval = 50;
  const checkInterval = setInterval(() => {
    if (typeof mazing === 'function') {
      clearInterval(checkInterval);
      resolve();
    }
  }, interval);
});

const waitForMazingRefresh = new Promise((resolve) => {
  const interval = 50;
  const t = setInterval(() => {
    if (typeof mazingRefreshSKU === 'function') {
      clearInterval(t);
      resolve();
    }
  }, interval);
});

const normalizeUmlauts = (s) =>
  String(s || '')
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
    .replace(/Ä/g, 'Ae').replace(/Ö/g, 'Oe').replace(/Ü/g, 'Ue')
    .replace(/ß/g, 'ss');

const slugify = (s) => {
  if (!s) return '';
  s = String(s).replace(/\s*[x×]\s*/gi, ' x ');
  s = normalizeUmlauts(s)
    .toLowerCase()
    .replace(/[^a-z0-9\s\-]/g, ' ')
    .replace(/\s+/g, '-')
    .replace(/\-+/g, '-')
    .replace(/^\-|\-$/g, '');
  return s;
};

function buildSku() {
  const url = new URL(window.location.href);
  const pathParts = url.pathname.split('/').filter(Boolean);
  const handle = (pathParts[0] === 'products' ? pathParts[1] : pathParts[pathParts.length - 1]) || '';
  const handleSlug = slugify(handle);

  try {
    const variantSelects = document.querySelector('variant-selects');
    const variantIdInput = document.querySelector('input.js-product-variant-id-input[name="id"]');
    const variantId = variantIdInput?.value?.toString();

    if (variantSelects && variantId) {
      const jsonScript = variantSelects.querySelector('script[type="application/json"]');
      if (jsonScript?.textContent) {
        const variants = JSON.parse(jsonScript.textContent);
        const v = variants.find((it) => String(it.id) === variantId);
        if (v) {
          const sizeSlug = slugify(v.option1 || '');
          const colorSlug = slugify(v.option2 || '');
          return [handleSlug, sizeSlug, colorSlug].filter(Boolean).join('-');
        }
      }
    }

    const sizeChecked = document.querySelector('fieldset .size-picker input[type="radio"]:checked');
    const colorChecked = document.querySelector('fieldset.product-form__input--color input[type="radio"]:checked');
    const sizeSlugFB = slugify(sizeChecked?.value || '');
    const colorSlugFB = slugify(colorChecked?.value || '');
    if (sizeSlugFB || colorSlugFB) {
      return [handleSlug, sizeSlugFB, colorSlugFB].filter(Boolean).join('-');
    }
  } catch (e) {
    console.warn('buildSku: parsing failed, fallback to handle only:', e);
  }

  return handleSlug || url.pathname.split('/').filter(Boolean).pop() || '';
}

async function callRefreshSKUWithRetry(sku, customer, { retries = 6, delay = 200 } = {}) {
  if (typeof mazingRefreshSKU !== 'function') {
    await waitForMazingRefresh.catch(() => {});
  }
  for (let i = 0; i <= retries; i++) {
    if (typeof mazingRefreshSKU === 'function') {
      try {
        mazingRefreshSKU(sku, customer);
        return true;
      } catch (e) {}
    }
    await new Promise(r => setTimeout(r, delay));
  }
  console.warn('refreshSKU: gave up after retries');
  return false;
}

function keepButtonsPinnedToFirstMedia() {
  const BTN_SELECTOR = '.mazing-button-container';
  const MEDIA_SELECTOR = '.product-single__media';

  const waitForButtons = new Promise((resolve) => {
    const t = setInterval(() => {
      const el = document.querySelector(BTN_SELECTOR);
      if (el) { clearInterval(t); resolve(el); }
    }, 50);
  });

  waitForButtons.then((btn) => {
    const ensureMediaIsPositioned = (mediaEl) => {
      const style = window.getComputedStyle(mediaEl);
      if (style.position === 'static') {
        mediaEl.style.position = 'relative';
      }
    };

    const reattach = () => {
      const firstMedia = document.querySelector(MEDIA_SELECTOR);
      if (!firstMedia) return;
      ensureMediaIsPositioned(firstMedia);
      if (btn.parentElement !== firstMedia) {
        firstMedia.appendChild(btn);
        btn.style.opacity = '1';
      }
    };

    reattach();

    const getContainer = () => document.querySelector(MEDIA_SELECTOR)?.parentElement || document.body;
    let container = getContainer();

    const observer = new MutationObserver((mutations) => {
      let needsReattach = false;
      for (const m of mutations) {
        if (m.type === 'childList') {
          needsReattach = true; break;
        }
      }
      if (needsReattach) {
        setTimeout(reattach, 0);
      }
    });

    const observe = () => {
      observer.disconnect();
      container = getContainer();
      if (!container) return;
      observer.observe(container, { childList: true });
    };

    observe();

    const containerGuard = new MutationObserver(() => {
      const cur = getContainer();
      if (cur !== container) observe();
    });
    containerGuard.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('popstate', () => setTimeout(reattach, 0));

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t && (
        t.matches('variant-selects input[type="radio"], variant-selects select') ||
        t.matches('.size-picker input[type="radio"]') ||
        t.matches('fieldset.product-form__input--color input[type="radio"]') ||
        t.matches('input.js-product-variant-id-input[name="id"]')
      )) {
        setTimeout(reattach, 0);
      }
    }, true);

    document.addEventListener('shopify:section:load', () => setTimeout(reattach, 0));
    document.addEventListener('shopify:section:unload', () => setTimeout(reattach, 0));
  });
}

const getShopifyLanguage = () => {
  const scripts = document.querySelectorAll('script[type="application/ld+json"]');
  for (const script of scripts) {
    try {
      const data = JSON.parse(script.textContent);
      if (data.inLanguage) {
        return data.inLanguage.toLowerCase().split('-')[0];
      }
      if (data.offers && data.offers.inLanguage) {
        return data.offers.inLanguage.toLowerCase().split('-')[0];
      }
    } catch (e) {}
  }

  const pathMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
  if (pathMatch && ['en', 'de', 'fr', 'it', 'es'].includes(pathMatch[1])) {
    return pathMatch[1];
  }

  return (navigator.language || 'en').toLowerCase().split('-')[0];
};

const lang = getShopifyLanguage();

const translations = {
  viewIn3D: {
    en: 'View in 3D',
    de: 'In 3D ansehen',
    fr: 'Voir en 3D',
    es: 'Ver en 3D',
    it: 'Visualizza in 3D'
  },
  seeInYourSpace: {
    en: 'See in Your Space',
    de: 'In deinem Raum sehen',
    fr: 'Voir dans votre espace',
    es: 'Ver en tu espacio',
    it: 'Vedi nel tuo spazio'
  }
};

const getTranslatedText = (key) => {
  return translations[key][lang] || translations[key].en;
};

const initializeScript = async () => {
  try {
    await waitForMazingFunction;
    console.log('mazing is now available');

    mazing({
      customerName: 'SKYPERGOLACH',
      buttonConfiguration: {
        customStyle: `
          .mazing-button-container {
            position: absolute;
            bottom: 25px;
            left: 50%;
            transform: translateX(-50%);
          }
          .mazing-ar-btn-icon,
          .mazing-threed-btn-icon {
            filter: brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%);
          }
          .mazing-threed-btn,
          .mazing-ar-btn {
            width: 200px;
            background: rgba(255, 255, 255, 0.7) !important;
            box-shadow: none !important;
            display: flex;
            justify-content: center;
          }
          @media (max-width: 600px) {
            .mazing-threed-btn,
            .mazing-ar-btn {
              width: 140px;
            }
          }
        `,
        placementSelector: '.product-single__media',
        threedBtn: {
          enabled: true,
          customText: getTranslatedText('viewIn3D')
        },
        arBtn: {
          enabled: true,
          customText: getTranslatedText('seeInYourSpace')
        }
      },
      getSKU: () => {
        const sku = buildSku();
        console.log('extracted sku:', sku);
        return sku;
      }
    });

    keepButtonsPinnedToFirstMedia();

    function attachMazingVariantListeners() {
      const CUSTOMER = 'SKYPERGOLACH';
      let refreshTimeoutId = null;

      const scheduleRefresh = () => {
        if (refreshTimeoutId) clearTimeout(refreshTimeoutId);
        refreshTimeoutId = setTimeout(async () => {
          const sku = buildSku();
          console.log('[Mazing] scheduled refreshSKU with sku:', sku);
          await callRefreshSKUWithRetry(sku, CUSTOMER, { retries: 8, delay: 150 });
        }, 700);
      };

      document.addEventListener('click', (e) => {
        const label = e.target.closest('variant-selects label, label.size-card, fieldset.product-form__input--color label');
        const input = e.target.closest('variant-selects input[type="radio"], variant-selects select, .size-picker input[type="radio"], fieldset.product-form__input--color input[type="radio"], input.js-product-variant-id-input[name="id"]');
        if (label || input) {
          scheduleRefresh();
        }
      }, true);

      window.addEventListener('popstate', scheduleRefresh);

      Promise.allSettled([waitForMazingFunction, waitForMazingRefresh]).then(scheduleRefresh);
    }

    attachMazingVariantListeners();

    console.log('Mazing integration initialized successfully.');
  } catch (error) {
    console.error('Mazing Initialization failed:', error);
  }
};

initializeScript();